import { FlexColumn } from '@editor/components/utilities/layouts';
import { VerticallyScrollable } from '@repo/ui/deprecated/VerticallyScrollable';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ModalContentWrapper = styled(VerticallyScrollable)`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  // TODO we finally need a proper scroll container solution to avoid this https://app.clickup.com/t/86bx5mwr5
  padding-right: 0 !important;

  width: 100%;
  height: 100%;

  * {
    box-sizing: border-box;
  }

  ${QUERIES.laptopAndUp} {
    flex-direction: row;

    align-items: stretch;

    overflow-y: visible;

    & > :first-child {
      flex: 1 0 336px;
      box-sizing: border-box;
    }
  }
`;

export const RightPanelWrapper = styled(FlexColumn)`
  width: 100%;
  flex-grow: 1;
`;

export const RightPanelBlock = styled(VerticallyScrollable)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-bottom: 0;

  overflow-y: visible; // handled by ModalContentWrapper scroll on mobile

  ${QUERIES.laptopAndUp} {
    padding: 32px 32px 0 !important; // TODO remove !important after the https://app.clickup.com/t/86bx5mwr5

    overflow-y: scroll;
  }
`;

export const RightPanelFormBlock = styled.div`
  padding: 12px;
  background: ${themeStyle.varBackgroundAlt};
  border-radius: ${themeStyle.radiusLarge};

  ${QUERIES.largeTabletAndUp} {
    padding: 24px;
  }
`;

export const RightPanelBottomBlock = styled(FlexColumn)`
  padding: 0 12px;

  flex-grow: 1;

  ${QUERIES.largeTabletAndUp} {
    padding: 0 24px;
  }
`;

export const ActionButtonsWrapper = styled.div`
  bottom: 0;

  margin-top: auto;
  padding: 12px 24px 24px;

  ${QUERIES.largeTabletAndUp} {
    padding-bottom: 32px;
  }
`;
